import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import { History } from "history";
import { sendResetPasswordEmail } from "../../../context/auth/action";
import { IToastContext, ToastContext } from "../../../providers/Toast";
import { AuthState } from "../../../context/auth/auth/reducer";
import { ROUTES } from "../../../routing/routes";
import * as Yup from "yup";
import CustomInputEmail from "../../../components/shared/forms/input/CustomInputEmail";
import Button from "../../../components/shared/button/Button";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import _environment from "../../../_environment/_environment";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
}

interface FormFields {
  email?: string;
}

const PreRegisteredView = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // Access to the history instance that you may use to navigate.
  let history = useHistory();

  // Access to toast manager hook that you may use to show toasts.
  const { openToast } = useContext<IToastContext>(ToastContext);

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [pending, setPending] = useState<boolean>(false);
  const [requested, setRequested] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const submitForm = async (email: string) => {
    setPending(true);

    try {
      await sendResetPasswordEmail(email);
      setRequested(true);

      openToast({
        type: "success",
        title: "success.general.title",
        message: "success.email_sent",
        callback: () => {
        },
      });
    } catch (err) {
      openToast({
        type: "error",
        title: "errors.general.title",
        message: "errors.user_not_exists",
        callback: () => {
        },
      });
    } finally {
      setPending(false);
    }
  };

  // -----------------------------------------------------------------
  // f o r m
  // -----------------------------------------------------------------
  // Formik Initialisation data
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email("Invalid email address").required("Email is required!"),
    }),
    onSubmit: (values: any) => {
      submitForm(values.email);
    },
  });

  const handleSubmit = (data: any) => {
    if (!requested && !pending) {
      return formik.handleSubmit(data);
    } else {
      history.push(ROUTES.SIGN_IN);
    }
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------
  const renderForm = (): React.ReactNode => {
    return (
      <form className="user">
        <div className="form-group">
          <CustomInputEmail
            id="email"
            name="email"
            label={t("forms.email")}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            errors={formik.errors.email}
            touched={formik.touched.email}
          />
        </div>
        <Button
          loading={pending}
          disabled={pending}
          onClick={handleSubmit}
          submit={true}
          className={`btn btn-primary btn-block ${!!requested ? "hidden" : ""}`}
        >
          {t("forms.submit")}
        </Button>

        <Button className={`cursor-auto btn btn-primary btn-outline btn-block ${!requested ? "hidden" : ""}`}>
          {t("forms.check_your_inbox")}
        </Button>
      </form>
    );
  };

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    console.log("[PreRegisteredView] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    console.log("[PreRegisteredView] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to user in order to handle authorization
   */
  useEffect(() => {
    if (user) {
      history.push(ROUTES.HOME);
    }
  }, [user, history]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div className="main-content">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-7 col-md-9">
            <div className="box o-hidden my-5">
              {/*<div className={"alert alert-warning"}>
                Registrations are temporarily disabled
              </div>*/}
              <div className="logo-vertical-wrapper">
                <a href={_environment.baseURL}>
                  <img src={_environment.assets.logo} alt={t("title")}/>
                </a>
              </div>
              <div className="card-body p-0">
                <div className="p-4">
                  <div className="text-center">
                    <h1 className="h4 text-gray-900 mb-4">{t("pages.preRegistered.title")}</h1>
                    <p className="desc">{t("pages.preRegistered.description")}</p>
                  </div>
                  <br/>
                  {renderForm()}
                  <hr/>

                  <div className="text-center">
                    <Link className="link-label" to={ROUTES.SIGN_IN}>{t("forms.back_sign_in")}</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PreRegisteredView;
